import { Component } from '@angular/core';
import { CommonService } from 'app/service/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent {


  constructor(public commonService: CommonService) {  }

  getClass() {
    if(this.commonService?.pages?.logo_header_destra !== null && this.commonService?.pages?.logo_header_destra !== undefined) {
      return 'pt-1';
    } 
    return 'pt-3';
  }
}
